﻿import mixitup from 'mixitup'
import mixitupMultiFilter from './mixitup-multifilter.min.js'

const containerElSelector = '.lessons-page__grid'
const targetSelector = '.mix'
const noResultsText = document.querySelector('.lessons-page__no-results-text') as HTMLParagraphElement

/**
 * Define query string object
 */
interface QueryStringObject {
    arskurs?: string,
    amne?: string,
    tema?: string
}

/**
 * Create an instance of QueryStringObject from a string
 * @param str = input string (search string)
 * @returns an instance of QueryStringObject
 */
const createQueryObjectFromString = (str: string): QueryStringObject => {
    let query: QueryStringObject = {
        arskurs: '',
        amne: '',
        tema: ''
    }

    let splitString = str.split('&')

    splitString.forEach((s) => {
        if (s.includes('arskurs')) query.arskurs = s.split('=')[1]
        if (s.includes('amne')) query.amne = s.split('=')[1]
        if (s.includes('tema')) query.tema = s.split('=')[1]
    })

    return query
}

/**
 * Create a searchstring from a QueryStringObject object
 * @param query = an instance of QueryStringObject
 * @returns a search string
 */
const createSearchString = (query: QueryStringObject): string => {
    let str = ''

    str += (query.arskurs != '') ? '&arskurs=' + query.arskurs : ''
    str += (query.amne != '') ? '&amne=' + query.amne : ''
    str += (query.tema != '') ? '&tema=' + query.tema : ''

    str = str.replace('&', '?')

    return str
}

/**
 * Update the search string when a filter is toggled 
 */
const updateSearchString = () => {
    let queryString = ''

    let activeGrades = document.querySelectorAll('.grade-select.mixitup-control-active')
    let activeSubjects = document.querySelectorAll('.subject-select.mixitup-control-active')
    let activeThemes = document.querySelectorAll('.theme-select.mixitup-control-active')

    let gradesFilterString = ''
    let subjectsFilterString = ''
    let themesFilterString = ''

    if (activeGrades.length > 0) activeGrades.forEach((item) => { gradesFilterString += item.getAttribute('data-label-clean') + ',' })
    if (activeSubjects.length > 0) activeSubjects.forEach((item) => { subjectsFilterString += item.getAttribute('data-label-clean') + ',' })
    if (activeThemes.length > 0) activeThemes.forEach((item) => { themesFilterString += item.getAttribute('data-label-clean') + ',' })

    if (activeGrades.length > 0 || activeSubjects.length > 0 || activeThemes.length > 0) {

        let queryObject: QueryStringObject = {
            arskurs: gradesFilterString.replace(/,$/, ''),
            amne: subjectsFilterString.replace(/,$/, ''),
            tema: themesFilterString.replace(/,$/, '')
        }

        queryString = createSearchString(queryObject)
        window.history.replaceState({}, '', queryString)
    } else {
        let emptyHref = ''
        if (window.location.href.indexOf('?') > 0) emptyHref = window.location.href.split('?')[0]
        window.history.replaceState({}, '', emptyHref)
    }
}

/**
 * Activate filters on load
 * @param mixer = an instance of a mixitup mixer
 */
const activateFilters = (mixer: any) => {
    if (window.location.search.length > 1) {
        let initialQuery: QueryStringObject = createQueryObjectFromString(window.location.search)

        if (mixer != null) {
            let gradesArr = initialQuery.arskurs.split(',')
            let gradesSelectorsArr: string[] = []
            if (gradesArr[0] != '') gradesArr.forEach((grade) => { gradesSelectorsArr.push('[data-grade~=ak-' + grade + ']') })
            mixer.setFilterGroupSelectors('grade', gradesSelectorsArr)

            let subjectsArr = initialQuery.amne.split(',')
            let subjectsSelectorsArr: string[] = []
            if (subjectsArr[0] != '') subjectsArr.forEach((subject) => { subjectsSelectorsArr.push('[data-subject~=' + subject + ']') })
            mixer.setFilterGroupSelectors('subject', subjectsSelectorsArr)

            let themesArr = initialQuery.tema.split(',')
            let themesSelectorsArr: string[] = []
            if (themesArr[0] != '') themesArr.forEach((theme) => { themesSelectorsArr.push('[data-theme~=' + theme + ']') })
            mixer.setFilterGroupSelectors('theme', themesSelectorsArr)

            mixer.parseFilterGroups()
        }
    }
    else {
        let filterAllItems = document.querySelectorAll('.filter-all')
        
        if (filterAllItems.length > 0) {
            Array.from(filterAllItems).forEach(item => {
                item.classList.add('mixitup-control-active')
            })
        }
    }
}

/**
 * Set count in dropdown label
 * @param el = container element containing filter toggles
 */
const setActiveCount = (el: HTMLElement) => {
    const activeFilters = el.querySelectorAll('.mixitup-control-active.filter-select')
    const countContainer = el.querySelector('.filter--dropdown__toggle--count')
    const allLabel = el.querySelector('.filter-all')

    let countString = activeFilters.length > 0 ? '(' + activeFilters.length + ')' : ''

    if (activeFilters.length < 1) {
        allLabel.classList.add('mixitup-control-active')
    }
    countContainer.innerHTML = countString
}

/**
 * Update active count labels 
 */
const updateActiveCount = () => {
    setActiveCount(document.querySelector('[data-filter-group="grade"]'))
    setActiveCount(document.querySelector('[data-filter-group="theme"]'))
    setActiveCount(document.querySelector('[data-filter-group="subject"]'))
}

/**
 * Function to call on mix end
 */
const mixEndFunction = () => {
    if (noResultsText) noResultsText.style.display = 'none'
    updateSearchString()
    updateActiveCount()
}

export function initFilters() {
    if (document.querySelector(containerElSelector)) {
        mixitup.use(mixitupMultiFilter)

        const mixer = mixitup(containerElSelector, {
            selectors: {
                target: targetSelector
            },
            multifilter: {
                enable: true
            },
            animation: {
                enable: false
            },
            callbacks: {
                onMixEnd: mixEndFunction,
                onMixFail: () => { if (noResultsText) noResultsText.style.display = 'block' }
            }
        })

        activateFilters(mixer)
    }
}